import { produce } from 'immer';
import {
  PUBLIC_PAGE_DATA_GET,
  PUBLIC_PAGE_DETAILS_GET,
} from '../actions/public';

const initialState = {
  homepage: {},
  pageContent: {},
  menuLogo: {},
  menuLinks: [],
  footer: [],
  subFooter: [],
};

const publicReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case PUBLIC_PAGE_DATA_GET._SUCCESS: {
        const { response } = action;
        draft.homepage = response?.page;
        draft.menuLogo = response?.header?.logo || {};
        draft.menuLinks = [...(response?.header?.menu_items || [])];
        draft.footer = [...(response?.footer?.menu_items || [])];
        draft.subFooter = [...(response?.subfooter?.menu_items || [])];
        break;
      }

      case PUBLIC_PAGE_DETAILS_GET._SUCCESS: {
        draft.pageContent = action.response;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default publicReducer;
